import React from 'react';
import { CommentListEventItem } from './CommentListEventItem';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { faUserPlus } from '@fortawesome/pro-light-svg-icons';
import { CommentMessage } from '@ygtechnologies/bygr-frontend-chat';

interface Data {
    buyerName: string;
}

interface CommentListEventBuyerAcceptedInvitationProps {
    comment: CommentMessage;
    isAdditional?: boolean;
}

export const CommentListEventBuyerAcceptedInvitation = ({
    comment,
    isAdditional,
}: CommentListEventBuyerAcceptedInvitationProps) => {
    const data: Data = comment.data;
    return (
        <CommentListEventItem
            icon={faUserPlus}
            title={<Trans>{data.buyerName} has accepted the invitation</Trans>}
            topText={
                isAdditional
                    ? t`An additional buyer has been added to this unit, ${data.buyerName} will be able to see messages from when the previous accepted the invitation`
                    : t`Any message before this is not visible to ${data.buyerName}`
            }
        />
    );
};
